import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PATHS } from "../../utils";
import * as image from "../../resources/images";
import { useForm } from "react-hook-form";
import { MSG } from "../../utils/Messages";
import { CHAR_REGEX } from "../../utils/Regex";
import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import AddressForm from "../controls/AddressForm";
import { paymentUpdateInfo } from "../../redux/actions/APIs";
import { billingPlan } from "../../redux/actions";
import { getCapitalized } from "../../utils/helper";

const UserDetail = ({hanldeStep, selectedPlan})=>{
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();
    const {
          loggedInUser,
          billingDetails,
    } = useSelector((state) => state.collections);

    const {
            register,
            setValue,
            handleSubmit,
            reset,
            resetField,
            formState: { errors },
        } = useForm({ mode: "onTouched" });

        const [isSubmitClicked, setIsSubmitClicked] = useState(false);
        const [loading, setLoading] = useState(false);
        const [checkbox1, setcheckBox1] = useState(false);
        const [checkbox2, setcheckBox2] = useState(false);
        const [cvvCheck, setcvvCheck] = useState(false);
    
        const [cardNumberErr, setCardNumber] = useState();
        const [expiryErr, setExpiry] = useState();
    
        const [cvcErr, setCvc] = useState();

        useEffect(()=>{
            if(billingDetails){
                let userDetal = billingDetails?.billing_details;
                setValue("firstName", getCapitalized(userDetal?.name));
                // setValue("address1", userDetal?.address?.address1);
                // setValue("address2", userDetal?.address?.address2);
                // setValue("state", userDetal?.address?.state);
                // setValue("city", userDetal?.address?.city);
                // setValue("zip", userDetal?.address?.postal_code);


            }
        }, [billingDetails])
    
    const handleChange = (e, type) => {
            if (type === "number" && e.elementType === "cardNumber") {
                if (e?.complete) {
                    setCardNumber(undefined);
                } else if (e?.empty) {
                    setCardNumber(MSG.CARDREQ);
                } else {
                    setCardNumber(MSG.VALIDCARD);
                }
            }
    
            if (type === "expiry") {
                if (e?.complete) {
                    setExpiry(undefined);
                } else if (e?.empty) {
                    setExpiry(MSG.EXPDATEREQ);
                } else if (!e?.empty && !e?.complete) {
                    setExpiry(MSG.VALIDEXP);
                } else {
                    setExpiry(MSG.EXPDATEREQ);
                }
            }
            if (type === "number" && e.elementType === "cardCvc") {
                setcvvCheck(e.complete);
                if (e?.complete) {
                    setCvc(undefined);
                } else if (e?.empty && cvvCheck === false) {
                    setCvc(MSG.CVVREQ);
                } else if (!e?.empty && !e?.complete) {
                    setCvc(MSG.VALIDCVV);
                }
                // else {
                //   setCvc(MSG.CVVREQ);
                // }
            }
        };

    const CARD_ELEMENT_OPTIONS = {
		placeholder: "CVV/CVC",
	};

    useEffect(() => {
            if (Object.keys(errors).length > 0) {
                if (expiryErr) {
                    setCardNumber(MSG.CARDREQ);
                    setExpiry(MSG.EXPDATEREQ);
                    setCvc(MSG.CVVREQ);
                }
            }
        }, [errors, expiryErr]);

    const _onSubmit = async (values, event)=>{
        const card = elements?.getElement(CardNumberElement);
        const card1 = elements?.getElement(CardExpiryElement);
        const card2 = elements?.getElement(CardCvcElement);
        if (!cvvCheck) {
                    setCvc(MSG.CVVREQ);
                    return false;
        }
        if (card) {
				const { error, paymentMethod } = await stripe.createPaymentMethod({
					type: "card",
					card: card2,
					billing_details: {
						name: values.firstName,
						address: {
							city: values?.city,
							country: "US",
							line1: values?.address1,
							line2: values?.address2,
							postal_code: values?.zip,
							state: values?.state,
						},
					},
				});
                if (error) {
					if (error?.code === "card_declined") {
						setCardNumber(error.message);
					} else if (error?.code === "incorrect_cvc") {
						setCardNumber(error.message);
					}
					return false;
				}
                if (paymentMethod !== undefined && paymentMethod.id !== undefined && false) {
                    if (true) {
                        let data = {
                            paymentId: paymentMethod?.id,
                            learnerId: undefined,

                            line1: paymentMethod?.billing_details?.address?.line1,
                            line2: paymentMethod?.billing_details?.address?.line2,
                            city: paymentMethod?.billing_details?.address?.city,
                            state: paymentMethod?.billing_details?.address?.state,

                            country: "USA",
                            postal_code: paymentMethod?.billing_details?.address?.postal_code,
                            isCardModified: true,
                            subscriptionStripeId:
                                selectedPlan?.stripeId,
                            cardProvider: paymentMethod?.billing_details?.name,
                            cardNumber: paymentMethod?.card?.last4,
                            tnc: true,
                        };
                         dispatch(paymentUpdateInfo(loggedInUser?.id, data));
                    }
                }else{
                        let addressObj = paymentMethod?.billing_details?.address;
                        let getObj =  {
                            ...addressObj, 
                            address1 : addressObj?.line1, 
                            address2 : addressObj?.line2,
                            zip: addressObj?.postal_code,
                        };
                        paymentMethod.billing_details.address = getObj;
                        dispatch(billingPlan(paymentMethod));
                }

                       
            }
        hanldeStep(3);
    }

    // console.log("_onSubmit  : ", errors, selectedPlan);

    return(
        <div className="pricingcardlist">
              <h1>Subscription: Payment Information</h1>

              <div className="Subscription_formcontnr pt-3">
                <h3>Payment Method</h3>
                <p>Please fill the required information</p>
                <form onSubmit={handleSubmit(_onSubmit)}>
                <div className="form_Subs">
                  <div class="input-group w-48">
                    <label>Card Holder Name<span class="mandatoryField">*</span></label>
                    <div class="form-group">
                      <input 
                      type="text" 
                      maxlength="100" 
                      placeholder="Your Name..." 
                      className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                      {...register("firstName", {
                            required: {
                                value: true,
                                message: MSG.NAMEREQ,
                            },
                            pattern: {
                                value: CHAR_REGEX,
                                message: MSG.VALIDINFOREQ,
                            },
                            maxLength: {
                                value: 99,
                                message: MSG.MAX100CHREQ,
                            },
                        })
                        } 
                     />
                     {errors.firstName && (
                        <p className="text-danger">
                            {errors.firstName.message}
                        </p>
                    )}
                    </div>
                  </div>
                  <div class="input-group">
                        <label>Card Number<span class="mandatoryField">*</span>
                        <img src="/static/media/credit_card.f4eae5050a2093cf0988.png" /></label>
                        <div className="form-group">
                            <CardNumberElement
                                id="cc-number"
                                className={`form-control ${isSubmitClicked && cardNumberErr
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                onChange={(event) => {
                                    handleChange(event, "number");
                                }}
                            />

                            {(errors && isSubmitClicked) || cardNumberErr ? (
                                <p className="text-danger">{cardNumberErr}</p>
                            ) : (
                                ""
                            )}
                        </div>
                     </div>
                  <div className="flexone align-items-start">
                     
                    <div class="input-group w-48">
                      <label>Expiry Date<span class="mandatoryField">*</span>
                      </label>
                      <div className="form-group">
                        <CardExpiryElement
                            id="expiry"
                            className={`form-control ${isSubmitClicked && expiryErr ? "is-invalid" : ""
                                } `}
                            onChange={(event) => {
                                handleChange(event, "expiry");
                            }}
                        />

                        {(errors && isSubmitClicked) || expiryErr ? (
                            <p className="text-danger">{expiryErr}</p>
                        ) : (
                            ""
                        )}
                    </div>
                    </div>
                      <div class="input-group w-48">
                        <label>CVV<span class="mandatoryField">*</span>
                        </label>
                           <div className="form-group">
                            <CardCvcElement
                                id="cvc"
                                className={`form-control ${isSubmitClicked && cvcErr ? "is-invalid" : ""
                                    } `}
                                onChange={(event) => {
                                    handleChange(event, "number");
                                }}
                                options={CARD_ELEMENT_OPTIONS}
                            />

                            {(errors && isSubmitClicked) || cvcErr ? (
                                <p className="text-danger">{cvcErr}</p>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                  </div>
                  <h3 className="pdb-2 billing_address">Billing Address</h3>
                 <AddressForm
                    subScriptiopnUserDetail={true}
                    errors={errors}
                    register={register}
                    setValue={setValue}
                    addressData={billingDetails?.billing_details?.address}
                />
                  <div class="cardbutton_footer mt-4 text-right">
                    <button class="mybutton learnmore" onClick={()=>hanldeStep(1)}>Back</button>
                    <button class="mybutton" type="submit"> Proceed to Checkout</button></div>
                </div>
                </form>
               
              </div>
            </div>
    );
}
export default UserDetail;